import { MapTo } from "@adobe/aem-react-editable-components";
import { ReferralHistory } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const referralHistoryEditConfig = {
    emptyLabel: "ReferralHistory",
    isEmpty: (props) => !props.dateLabel || !props.eventLabel || !props.pointsLabel || !props.title,
    getProps: (props) => ({
        dateLabel: props.dateLabel,
        eventLabel: props.eventLabel,
        pointsLabel: props.pointsLabel,
        title: props.title,
        rowsCount: props.rowsCount,
        url: props.url,
        text: props.text,
        pointsUnit: props.pointsLabel,
        isInEditor: props.isInEditor,
    }),
};
export default MapTo("loyalty/components/referralhistory")(withAemAuthoring(ReferralHistory, referralHistoryEditConfig));
